import { AxiosError } from 'axios';

type Props = {
  error: any;
  defaultMessage?: string;
};

export const errorMessage = ({ error, defaultMessage = 'An error occurred.' }: Props): string =>
  (error as AxiosError<any>).response?.data.detail ||
  (error as AxiosError<any>).response?.data.title ||
  defaultMessage;
